import React from 'react';
import '../../../../Stylesheets/Dashboard/ProjectCards.css';
import { Link } from 'react-router-dom';
import { FaChevronRight } from 'react-icons/fa';

const ProjectCards = ({ projects }) => {
  return (
    <div className="overview-project-cards-wrapper">
      <div className="overview-project-cards-header">
        <h3 className="overview-section-title-projects">Projects</h3>
        <a href="/dashboard/projects" className="overview-see-all-link">See All</a>
      </div>
      <div className="overview-projects-grid">
        {projects.map((project) => (
          <div key={project.id} className="overview-project-card">
            <div className="overview-project-image" style={{ backgroundImage: `url(${project.banner || 'https://wordpress.bricknbolt.com/blogs-and-articles/wp-content/uploads/sites/2/2024/07/House-Construction-in-India.webp'})` }}>
              <div className="overview-project-status">Active</div>
            </div>
            <div className="overview-project-content">
              <h3>{project.name}</h3>
              <p>{project.location}</p>
            </div>
            <Link to={`/dashboard/project/${project._id}`} className="no-link-style">
              <button className="overview-view-project-btn">
                <span>View Project</span>
                <FaChevronRight />
              </button>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProjectCards;
